import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosGet from "../axios/axios-get";
import axiosDelete from "../axios/axios-delete";

export const ContactAPI = Object.freeze({
  getAll: createAsyncThunk(
    "get/get-contacts",
    async (params, { rejectWithValue }) => {
      try {
        const response = await axiosGet.get("/contact", { params });
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  ),

  getOne: createAsyncThunk(
    "get/one-contact",
    async (id, { rejectWithValue }) => {
      try {
        const response = await axiosGet.get(`/contact/${id}`);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  ),

  delete: createAsyncThunk(
    "delete/delete-contact",
    async (id, { rejectWithValue }) => {
      try {
        const response = await axiosDelete.delete(`/contact/${id}`);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  ),
});
